import React, { useEffect, useState } from 'react'
import EditText, { EditTextPassword } from 'blocks.simple/editText/editText'
import deepEqual from 'fast-deep-equal'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './styles'
import { text as textStyles } from 'theme'
import grid from 'blocks.simple/grid/grid.jcss'
import { Typography } from 'atoms/Typography'

const NovastarAuthorizationSettings = (p_: { onChange: (data: any) => void; settings: any }) => {
    const onChangeField = (field: string, value: string) => {
        p_.onChange({ ...p_.settings, [field]: value })
    }

    return (
        <div className={grid.mb_mdPlus}>
            <Typography className={cn(textStyles.normal, styles.caption)} type="title">
                {translate('login')}
            </Typography>
            <div className={styles.fieldsWrapper}>
                <EditText
                    mod={'withBorder'}
                    label={translate('adLogin')}
                    value={p_.settings.login || ''}
                    onChange={function (login: any) {
                        onChangeField('login', login)
                    }}
                    containerClass={styles.inputWrapper}
                />
                <EditTextPassword
                    mod={'withBorder'}
                    label={translate('password')}
                    value={p_.settings.password || ''}
                    onChange={function (password: string) {
                        onChangeField('password', password)
                    }}
                    containerClass={styles.inputWrapper}
                />
            </div>
        </div>
    )
}

export default NovastarAuthorizationSettings
